<header id="main_header" class="fixedHeader" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1000">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <nav class="navbar navbar-expand-xl navbar-light">
                    <a class="navbar-brand" [routerLink]="['/']" routerLinkActive="active">
                        <!-- <img src="../../../assets/images/trinka-logo.png" /> -->
                        <img src="../../../assets/images/trinka_logo.svg" alt="trinka logo">
                    </a>

                    <div class="mobile_buttons">
                        <button class="mobile_try_a_demo_button">Try A Demo</button>
                        <a class="mobile_login" href="https://cloud.trinka.ai" target="_blank">
                            <span>免費註冊
                                <!-- <span class="small_mobile_only">for Free</span> -->
                            </span>
                            <i class="fa fa-sign-in" aria-hidden="true"></i>
                        </a>
                        <a class="mobile_login" href="https://cloud.trinka.ai/signin?_rg=TW" target="_blank">
                            <span class="diplay_none_for_icons">登錄</span>
                            <i class="fa fa-sign-in display_block_for_text" aria-hidden="true"></i>
                        </a>

                        <div class="navbar-nav ml-auto loginarea">

                        </div>

                        <button type="button" class="navbar-toggler" id="mobile_menu_toggle" data-toggle="collapse" data-target="#navbarCollapse">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 384.97 384.97" style="enable-background:new 0 0 384.97 384.97;" xml:space="preserve">
                                <g>
                                    <g id="Menu_1_">
                                        <path d="M12.03,120.303h360.909c6.641,0,12.03-5.39,12.03-12.03c0-6.641-5.39-12.03-12.03-12.03H12.03
                         c-6.641,0-12.03,5.39-12.03,12.03C0,114.913,5.39,120.303,12.03,120.303z" />
                                        <path d="M372.939,180.455H12.03c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03
                         S379.58,180.455,372.939,180.455z" />
                                        <path d="M372.939,264.667H132.333c-6.641,0-12.03,5.39-12.03,12.03c0,6.641,5.39,12.03,12.03,12.03h240.606
                         c6.641,0,12.03-5.39,12.03-12.03C384.97,270.056,379.58,264.667,372.939,264.667z" />
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </button>
                        <div id="body_overlay_section"></div>
                    </div>

                    <div class="collapse navbar-collapse" id="navbarCollapse">
                        <ul class="navbar-nav mr-auto">

                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['']" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">主頁</a>
                            </li> -->
                            <li class="nav-item dropdown" id="main_sub_menus">
                                <a class="nav-link dropdown-toggle" href="" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    應用程式
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="Home_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [routerLink]="['/trinkacloud']" routerLinkActive="active">
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud" style="height: 28px;"> Trinka Cloud</a>

                                    <a class="nav-link" [routerLink]="['/wordplugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word"> Word外掛程式</a>

                                    <a class="nav-link" [routerLink]="['/browser-plugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="browser"> 瀏覽器外掛程式</a>
                                </div>
                            </li>
                            <li class="nav-item dropdown" id="feature_main_sub_menus">
                                <a class="nav-link dropdown-toggle" [routerLink]="['/features']" id="dropdown05" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">特色
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="feature_sub_menus" aria-labelledby="dropdown05">
                                    <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">
                                        所有功能
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">
                                        抄襲檢測
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/tw/features/auto-file-edit" routerLinkActive="active">
                                        自動文件編輯
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/tw/features/publication-readiness-checks" routerLinkActive="active">
                                        出版準備檢查
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/citation-checker']" routerLinkActive="active">
                                        引文檢查器
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/consistency-check']" routerLinkActive="active">
                                        一致性檢查
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">
                                        個人詞典
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/credits']" routerLinkActive="active">
                                        Trinka積分
                                    </a>
                                </div>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">特色</a>
                            </li> -->
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/examples']" routerLinkActive="active">案例</a>
                            </li> -->
                            <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">價格</a>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/enterprise']" routerLinkActive="active">企業</a>
                            </li> -->
                            <li class="nav-item dropdown" id="enterprise_main_sub_menus">
                                <a class="nav-link" id="enterpriseMainMenu" [routerLink]="['/enterprise']" routerLinkActive="active">企業
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="enterprise_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">
                                        生命科學、醫學和製藥
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">
                                        語言服務、出版和媒體
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">
                                        學術機構
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">
                                        K-12和數位化學習
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">
                                        技術平台
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">
                                        語法檢查工具API
                                    </a>
                                </div>
                            </li>
                            <li class="nav-item dropdown" id="resources_main_sub_menus">
                                <a class="nav-link" href="javascript:void(0)"  routerLinkActive="active">資源
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="resources_sub_menus" aria-labelledby="dropdown06" style="min-width: 200px;">
                                    <a class="nav-link" [routerLink]="['/grammar-checker']" routerLinkActive="active">
                                        文法檢查
                                     </a>
                                     <a class="nav-link" [routerLink]="['/punctuation-checker']" routerLinkActive="active">
                                        標點符號檢查工具
                                     </a>
                                     <a class="nav-link" [routerLink]="['/spell-checker']" routerLinkActive="active">
                                        拼寫檢查工具
                                     </a>
                                     <a class="nav-link" [routerLink]="['/sentence-checker']" routerLinkActive="active">
                                        句子檢查工具
                                     </a>
                                </div>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link"  id="apiGrammarChecker" [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">
                                    API
                                </a>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/try-a-demo']" routerLinkActive="active">嘗試演示</a>
                            </li> -->
                        </ul>
                        <div class="navbar-nav ml-auto loginarea">
                            <a class="nav-item nav-link login_buttons signup_buttons_new" href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊 </a>
                            <a class="nav-item nav-link login_buttons login_buttons_new" href="https://cloud.trinka.ai/signin?_rg=TW" target="_blank">登錄 </a>
                        </div>
                    </div>


                    <div class="language_sections" id="languageDropDown">
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        <span>繁体中文</span>
                        <ul class="drop">
                            <li>
                                <a href="https://www.trinka.ai/">English</a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/jp/">
                                    日本語
                                </a>
                            </li>
                            <li>
                                <a href="https://trinka.enago.cn/">
                                    简体中文
                                </a>
                            </li>
                            <li class="selected">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    繁体中文
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/kr/">
                                    한국어
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/es/">
                                    Español
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/pt/">
                                    Português
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</header>